import { useEffect } from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { EditorContextSidebarAction, editorContextSidebarStore } from '../editorContextSidebarStore';

export function useEditorContextSidebar() {
  const pane = useSyncExternalStore(editorContextSidebarStore.subscribe, editorContextSidebarStore.getSnapshot);

  return {
    pane,
    toggle: editorContextSidebarStore.toggle,
    set: editorContextSidebarStore.set,
    callAction: editorContextSidebarStore.callAction,
  };
}

export function useEditorContextSidebarActions(actions: Partial<Record<EditorContextSidebarAction, () => void>>) {
  const action = useSyncExternalStore(editorContextSidebarStore.subscribe, editorContextSidebarStore.getActionSnapshot);

  useEffect(() => {
    const actionCallback = action && actions[action];
    if (actionCallback) {
      actionCallback();
      editorContextSidebarStore.clearAction();
    }
  }, [action, actions]);
}
